export const thunkTypes = {
  LIST_DELIVERIES: `allDeliveries/listDeliveries`,
  LOAD_MORE: `allDeliveries/loadMore`,
  EXPORT_DELIVERIES: `allDeliveries/exportDeliveries`,
  LIST_AMBASSADORS: `allDeliveries/listAmbassadors`,
  LIST_ADDRESSES: `allDeliveries/listAddresses`,
  REASSIGN: `allDeliveries/reassign`,
  RESCHEDULE: `allDeliveries/reschedule`,
};
